import React from "react";
import "../../../styles/main.css";
import PageHeader from "../../../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";
import Subpage_107 from "../../../modules/caneva/Subpage_107";

const Page_107 = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        minWidth: 1200,
        minHeight: 0,
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          flex: "0 0 auto",
          minWidth: 0,
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Breadcrumb
          items={[
            { label: "homepage", href: "/Homepage" },
            { label: "caneva / budget", href: "/page_107" },
          ]}
        />

        {/* <PageHeader
          title="Budget"
          className="title-caneva"
        />

        <hr className="page-separator" /> */}
      </div>

      <main
        className="content"
        style={{
          flex: "1 1 auto",
          width: "100%",
          minWidth: 0,
          minHeight: 0,
          padding: 0,
          margin: 0,
          background: "transparent",
          overflow: "hidden",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            flex: "1 1 auto",
            width: "100%",
            height: "100%",
            minWidth: 0,
            minHeight: 0,
            overflow: "hidden",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Subpage_107 />
        </div>
      </main>
    </div>
  );
};

export default Page_107;